import { useSearchParams } from 'react-router-dom';

import { DatabricksEmbedDashboard } from '~/components/DatabricksEmbedDashboard/DatabricksEmbedDashboard';
import { Spinner } from '~/components/Spinner';
import { ErrorContent } from '~/modules/errors/components/ErrorContent';
import { useMarketingCampaignsDashboardQuery } from '~/modules/marketing/pages/digital-campaign-performance/hooks/useMarketingCampaignsDashboardQuery';

export function DigitalCampaignPerformancePage() {
  const [searchParams] = useSearchParams();
  const campaignId = searchParams.get('campaign_id') ?? undefined;

  const { data: dashboardConfig, isLoading } =
    useMarketingCampaignsDashboardQuery(campaignId);

  const dashboardView = dashboardConfig ? (
    <div className="flex min-h-0 flex-1">
      <DatabricksEmbedDashboard
        config={dashboardConfig}
        ariaLabel="digital-campaign-performance-dashboard"
      />
    </div>
  ) : (
    <ErrorContent type="default" variant="inline" />
  );

  return (
    <div className="flex h-full flex-col">
      {isLoading ? (
        <div className="flex h-full items-center justify-center">
          <Spinner size="md" />
        </div>
      ) : (
        dashboardView
      )}
    </div>
  );
}

DigitalCampaignPerformancePage.displayName = 'DigitalCampaignPerformancePage';
